import Vue from 'vue';

const INIT_TRIGGER_STATE = { trigger: 0 };

export const updateSdsCountSignal = Vue.observable(
  JSON.parse(JSON.stringify(INIT_TRIGGER_STATE))
);

export const updateSdsCount = () => updateSdsCountSignal.trigger++;

export const updateSdsCountDoneSignal = Vue.observable(
  JSON.parse(JSON.stringify(INIT_TRIGGER_STATE))
);

export const updateSdsCountDone = () => updateSdsCountDoneSignal.trigger++;
